import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { QuestionSupport } from '../../enums/question-support.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'questionSupport',
  standalone: false
})
export class QuestionSupportPipe implements PipeTransform {
  public transform(value: QuestionSupport): string {
    return getQuestionSupport(value);
  }
}

export function getQuestionSupport(value: QuestionSupport): string {
  switch (value) {
    case QuestionSupport.None:
      return 'None';
    case QuestionSupport.Summary:
      return 'Summary';
    case QuestionSupport.Collecting:
      return 'Collecting';
    default:
      throw new Error(`Unsupported value for QuestionSupport: ${value}.`);
  }
}

export function getQuestionSupportList(): IdName[] {
  return enumToList(QuestionSupport, getQuestionSupport);
}

export function getPeQuestionSupportList(): IdName[] {
  return getQuestionSupportList().filter((x) => x.id !== QuestionSupport.Summary);
}
